
export function formatStationForAPI(stationName) {
  if (!stationName) return '';
  
  return stationName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function getExactStationName(input, suggestions) {
  if (!input || !suggestions?.length) return null;
  const normalizedInput = input.toLowerCase().trim();
  return suggestions.find(station => station.toLowerCase().trim() === normalizedInput) || null;
}

export function findBestMatch(input, suggestions, maxDistance = 3) {
  if (!input || !suggestions?.length) return null;

  const normalizedInput = input.toLowerCase().trim();
  let bestMatch = null;
  let minDistance = Infinity;

  for (const station of suggestions) {
    const normalizedStation = station.toLowerCase().trim();
    const distance = levenshteinDistance(normalizedInput, normalizedStation);
    
    if (distance < minDistance && distance <= maxDistance) {
      minDistance = distance;
      bestMatch = station;
    }
  }

  return bestMatch;
}

function levenshteinDistance(str1, str2) {
  const m = str1.length;
  const n = str2.length;
  const dp = Array(m + 1).fill().map(() => Array(n + 1).fill(0));

  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;

  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (str1[i - 1] === str2[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] = 1 + Math.min(
          dp[i - 1][j],
          dp[i][j - 1],
          dp[i - 1][j - 1]
        );
      }
    }
  }

  return dp[m][n];
}
